/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ingle_Claims_Medical_TitleInputs */

const en_ingle_claims_medical_title = /** @type {(inputs: Ingle_Claims_Medical_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medical Claim Form`)
};

const fr_ingle_claims_medical_title = /** @type {(inputs: Ingle_Claims_Medical_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire de réclamation médicale`)
};

/**
* | output |
* | --- |
* | "Medical Claim Form" |
*
* @param {Ingle_Claims_Medical_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const ingle_claims_medical_title = /** @type {((inputs?: Ingle_Claims_Medical_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ingle_Claims_Medical_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ingle_claims_medical_title(inputs)
	return fr_ingle_claims_medical_title(inputs)
});